export declare const player: (player: Player) => void;
declare global {
}
